import type { LoaderOptions } from '@/loaders/LoaderOptions';

import {
  getCombinedCampaignsQueryOptions,
  getIndividualProductsQueryOptions,
  unitByIdQueryOptions,
} from '@/service/vpc/queryOptions';
import { chassis } from '@/utils';

export const loaderUnitCampaignsPage = async (opts: LoaderOptions) => {
  const { endCustomerUnitId } = opts.params;

  if (!endCustomerUnitId) {
    return;
  }

  // First fetch the unit data to get serial numbers
  const unitData = await opts.context.queryClient.ensureQueryData(unitByIdQueryOptions({ endCustomerUnitId }));

  // Extract serial numbers from the unit data
  const serialNumbers = chassis.getUnitSerialNumbers(unitData) || [];

  // Prefetch campaigns and products data in parallel
  if (serialNumbers.length > 0) {
    await Promise.all([
      opts.context.queryClient.ensureQueryData(
        getCombinedCampaignsQueryOptions({ endCustomerUnitIds: [endCustomerUnitId], serialNumbers })
      ),
      opts.context.queryClient.ensureQueryData(getIndividualProductsQueryOptions({ serialNumbers })),
    ]);
  }
};
